export const handleWhatsAppClick = (message = '', phone = '38999361310') => {
  const messageEncode = encodeURIComponent(message);
  window.open(`https://wa.me/${phone}?text=${messageEncode}`, '_blank');
};